// 7-day total scans chart — single area chart aggregating scans
// across the user's entire portfolio. Pattern lifted from
// CodeAnalyticsPage::ScansOverTimeChart so we don't add a charting
// library dep for what's a 7-point polyline. `daily` is exactly
// [{date, count}] x 7 (zero-filled server-side).
export default function SevenDayChart({ daily, loading }) {
  if (loading) {
    return (
      <ChartCard>
        <div className="h-24 flex items-center justify-center text-xs text-[color:var(--color-muted)] dark:text-muted-light">
          loading…
        </div>
      </ChartCard>
    )
  }

  const total = daily.reduce((sum, d) => sum + d.count, 0)
  if (total === 0) {
    return (
      <ChartCard>
        <div className="h-24 flex items-center justify-center text-xs text-[color:var(--color-muted)] dark:text-muted-light text-center px-4">
          No scans yet — share your codes.
        </div>
      </ChartCard>
    )
  }

  const width  = 600
  const height = 100
  const peak   = Math.max(1, ...daily.map((d) => d.count))
  const stepX  = daily.length > 1 ? width / (daily.length - 1) : 0
  const coords = daily.map((d, i) => [ i * stepX, height - (d.count / peak) * (height - 10) - 2 ])
  const linePath = coords.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(" ")
  const fillPath = `${linePath} ${width},${height} 0,${height}`

  return (
    <ChartCard>
      <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" className="w-full h-24">
        <polyline points={fillPath} fill="var(--color-voltage)" fillOpacity="0.08" stroke="none" />
        <polyline points={linePath} fill="none" stroke="var(--color-voltage)" strokeWidth="2" />
      </svg>
      <div className="flex justify-between text-[10px] text-[color:var(--color-muted)] dark:text-muted-light mt-1 font-mono">
        <span>{daily[0]?.date}</span>
        <span>{daily[daily.length - 1]?.date}</span>
      </div>
    </ChartCard>
  )
}

function ChartCard({ children }) {
  return (
    <div className="bg-white dark:bg-midnight border border-[color:var(--color-border)] dark:border-storm rounded-lg p-4">
      <div className="text-xs uppercase tracking-wider text-[color:var(--color-muted)] dark:text-muted-light font-semibold mb-2">
        Total scans · 7d
      </div>
      {children}
    </div>
  )
}
